import React from 'react'
import styled from 'styled-components'
import CTASection from '../components/sections/CTASection'
import FAQBanner from '../components/sections/FAQBanner'
import FAQSection from '../components/sections/FAQSection'
import useScrollToTop from '../hooks/useScrollToTop'

export default function FAQPage() {
	useScrollToTop()

	return (
		<Block>
			<FAQBanner />
			<FAQSection />
			<CTASection />
		</Block>
	)
}

const Block = styled.div``
